<div class="table-responsive audit-table-wrapper h-100">
    <ag-grid-table [localStorageKey]="localStorageKey"
                   [rows]="records"
                   [enableRtl]="isRtl"
                   [gridOptions]="gridOptions"
                   [columnDefs]="columns | async">
    </ag-grid-table>
</div>
